import React from "react";

export const iconSizes = {
    none: undefined,
    xxsmall: 3.5,
    xsmall: 7,
    small: 10.5,
    medium: 14,
    large: 21,
    xlarge: 28,
    xxlarge: 42,
}

export interface IconWrapProps {
    viewBox?: string;
    className?: string;
    style?: React.CSSProperties;
    size?: keyof typeof iconSizes,
    children: React.ReactNode;
}

const IconWrap = ({ size = "medium", viewBox = "0 0 28 28", className, children, style, ...rest }: IconWrapProps) => (
    <svg width={iconSizes[size]} height={iconSizes[size]} viewBox={viewBox} className={className} xmlns="http://www.w3.org/2000/svg" style={style} {...rest}>
        {children}
    </svg>
);

export default IconWrap;
